export default {
    SERVICE_ID: `service_z63dat8`,
    USER_ID: `user_2RWAXC63vYrsc5fYlO99r`, 
    TEMPLATE_ID:'site_contact'
};